import React, { useState } from 'react';
import css from './DestinationFaq.module.css';
import BrandIconCard from '../BrandIconCard/BrandIconCard';
import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import { FormattedMessage } from 'react-intl';

const DestinationFaq = ({ blocks = [], options, title }) => {
  const [activeTab, setActiveTab] = useState('host');
  const [expandedIndex, setExpandedIndex] = useState(null);

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  // Each FAQ item is a separate block. blockId is exactly 'host-faq' or 'guest-faq'
  const hostBlocks = blocks.filter(b => b?.blockId === 'host-faq');
  const guestBlocks = blocks.filter(b => b?.blockId === 'guest-faq');

  const activeBlocks = activeTab === 'host' ? hostBlocks : guestBlocks;

  const handleTabChange = tab => {
    setActiveTab(tab);
    setExpandedIndex(null); // reset open accordion when switching tabs
  };

  const toggleFaq = index => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className={css.faqSection}>
      {hasDataInFields([title], fieldOptions) ? (
        <Field data={title} options={fieldOptions} />
      ) : (
        <h2 className={css.faqTitle}><FormattedMessage id="FAQ.heading1" /></h2>
      )}

      <div className={css.toggleContainer}>
        <button
          className={`${css.toggleButton} ${activeTab === 'host' ? css.active : ''}`}
          onClick={() => handleTabChange('host')}
        >
          <FormattedMessage id="FAQ.host" />
        </button>
        <button
          className={`${css.toggleButton} ${activeTab === 'guest' ? css.active : ''}`}
          onClick={() => handleTabChange('guest')}
        >
          <FormattedMessage id="FAQ.guest" />
        </button>
      </div>

      <div className={css.faqGrid}>
        {activeBlocks.map((block, index) => {
          const { title, text } = block;
          const hasTitle = hasDataInFields([title], fieldOptions);
          const hasText = hasDataInFields([text], fieldOptions);
          const isOpen = expandedIndex === index;

          return (
            <div key={index} className={css.faqItem}>
              <div
                className={css.faqQuestion}
                onClick={() => toggleFaq(index)}
              >
                <span>
                  {hasTitle ? <Field data={title} options={fieldOptions} /> : null}
                </span>
                <span className={`${css.plusIcon} ${isOpen ? css.rotate : ''}`}>
                  {isOpen ? (
                    <BrandIconCard type="minus" />
                  ) : (
                    <BrandIconCard type="plus" />
                  )}
                </span>
              </div>

              {isOpen && hasText ? (
                <div className={css.faqAnswer}>
                  <Field data={text} options={fieldOptions} />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DestinationFaq;
